import { DEFAULT_LANG } from '@rover/constants/src/i18n/language';

import generateExternalFormatMap from './generateExternalFormatMap';
import generateFormatMapForLang from './generateFormatMap';
import getLocalizedFormatContextless from './getLocalizedFormatContextless';

export const getExternalFormatMap = (language?: string): Record<string, string> =>
  generateExternalFormatMap(getLocalizedFormatContextless, language);

export const getDateTimeFormatMapForLang = (language?: string): Record<string, string> =>
  generateFormatMapForLang(getLocalizedFormatContextless, language);

export const defaultDateTimeFormatMap = getDateTimeFormatMapForLang(DEFAULT_LANG);

// Default export for backward compatibility
export { getDateTimeFormatMapForLang as default };

// Additional exports
export { getLocalizedFormatContextless as getLocalizedFormat };
